/** Channel name for cross-window logout signaling via BroadcastChannel */
export const NEXUS_LOGOUT_CHANNEL = 'nexus:logout';

/** Window name for the pipeline logs popup */
export const PIPELINE_LOGS_WINDOW_NAME = 'nexus-pipeline-logs';
